<template>
    <div class="modal-dps-div" style="max-height: 350px; overflow-y: auto;">
        <div v-html="conteudoTermo"></div>
    </div>
</template>

<script>
    import store from "../store"

    export default {
        name: "TermoLGPD",

        data() {
            return {
                conteudoTermo: store.getters.getAliancaTermos
            };
        },
    }
</script>